export async function fetchSharpCharts2XML(styleCacheId: string): Promise<string> {
  const urlSearchParams = new URLSearchParams({
    id: styleCacheId,
    randomNumber: Date.now().toString()
  });

  let responseText: string;

  try {
    const response = await fetch(`/stylecache/cache?${urlSearchParams.toString()}`, {
      method: 'GET'
    });

    responseText = await response.text();

    window.sc3WorkbenchLogger.info(`stylecache GET responseText for styleCacheId: ${styleCacheId}`, responseText);
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Failed to fetch SharpCharts2 chart XML for chart with styleCacheId: ${styleCacheId}.`, e);

    throw new Error(`Failed to fetch SharpCharts2 chart XML for chart with styleCacheId: ${styleCacheId}.`, { cause: e });
  }

  if (!responseText.trim()) {
    throw new Error(`Failed to fetch SharpCharts2 chart XML for chart with styleCacheId: ${styleCacheId} - trimmed responseText is an empty string.`);
  }

  return responseText.trim();
}
